/**
 * Mô tả một build pet trong bộ giả lập, và cách gửi nó cho máy chủ.
 *
 * Trạng thái trên giao diện giữ trang bị theo LOẠI (vũ khí / giáp / mũ / giày / bao tay) để mỗi ô
 * là một chỗ cố định; còn API nhận một danh sách phẳng, nên `toRequest` dẹp lại trước khi gửi.
 */

export const ROLL_OPTIONS = [
  { value: "max", label: "Tối đa của mẫu" },
  { value: "avg", label: "Trung bình" },
  { value: "min", label: "Tối thiểu" },
  { value: "custom", label: "Tự nhập" },
];

export function emptyGear() {
  return {
    templateId: null,
    roll: "max",
    atk: 0,
    def: 0,
    hp: 0,
    mp: 0,
    lvl: 0,
    fusion: 0,
    gems: [null, null, null],
  };
}

export function emptyBuild() {
  return {
    petTemplateId: null,
    lvl: 1,
    tiemnang: [0, 0, 0],
    pointPerLevel: null,
    equips: {},
    wing: emptyGear(),
    skin: emptyGear(),
    tattoos: [],
    titleId: -1,
    passives: [],
  };
}

/** Trang bị của một ô, tạo mới nếu ô đó còn trống. */
export function gearOf(build, type) {
  return build.equips[type] || emptyGear();
}

const gearRequest = (gear) =>
  !gear || !gear.templateId
    ? null
    : {
        templateId: gear.templateId,
        roll: gear.roll,
        atk: gear.atk,
        def: gear.def,
        hp: gear.hp,
        mp: gear.mp,
        lvl: gear.lvl,
        fusion: gear.fusion,
        gems: gear.gems.map((g) =>
          g && g.templateId ? { templateId: g.templateId, lvl: g.lvl } : null
        ),
      };

/** Dạng gửi lên POST /api/admin/simulate/pet. */
export function toRequest(build) {
  return {
    petTemplateId: build.petTemplateId,
    lvl: build.lvl,
    tiemnang: build.tiemnang,
    pointPerLevel: build.pointPerLevel,
    equips: Object.values(build.equips).map(gearRequest).filter(Boolean),
    wing: gearRequest(build.wing),
    skin: gearRequest(build.skin),
    tattoos: build.tattoos.filter((t) => t.templateId),
    titleId: build.titleId,
    passives: build.passives.filter((p) => p.skillId),
  };
}
